import SideNavDesktop from './SideNavDesktop';
import SideNavMobile from './SideNavMobile';
import { useSidebar } from '../../context/SidebarContext';

export default function SideNav() {
  const { isMobile } = useSidebar();
  
  if (isMobile) {
    return <SideNavMobile />;
  }
  
  return <SideNavDesktop />;
}
